
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[parent]/[id]",
      function () {
        return require("private-next-pages/[parent]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[parent]/[id]"])
      });
    }
  